module.exports = __webpack_public_path__ + "resource/img/image005.076b79d4.png";